import { ETH_GAS_PRICE_ENDPOINT } from '../constants';

const BigNumber = require('bignumber.js');

/**
 * Fetches the current recommended gas prices.
 *
 * @returns {Ojbect} the gas prices - gwei.
 */
const fetchRecommendedGasPrices = async () =>
  fetch(ETH_GAS_PRICE_ENDPOINT)
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      const error = new Error(`Received ${response.status} while attempting to fetch gas`);
      error.body = response.json();
      throw error;
    })
    .then((data) => {
      const safeLow = BigNumber(data.safeLow);
      const average = BigNumber(data.average);
      const fast = BigNumber(data.fast);
      // Values are actually 10x gwei. Round to nearest 5, then convert to gwei.
      return {
        safeMin: parseFloat(safeLow
          .div(5)
          .integerValue()
          .times(0.5)
          .toFixed(1)),
        standard: parseFloat(average
          .div(5)
          .integerValue()
          .times(0.5)
          .toFixed(1)),
        fast: parseFloat(fast
          .div(5)
          .integerValue()
          .times(0.5)
          .toFixed(1)),
      };
    });

export default fetchRecommendedGasPrices;



// WEBPACK FOOTER //
// ./src/services/fetchGasPrices.js